class GetFrecuencias {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute() {
    const frecuencias = await this.#repository.getFrecuencias()
    return frecuencias
  }
}

export default GetFrecuencias
